import type { LeadAssigneePickerLabels } from '@/core/components/leads/lead-assignee-picker';

type AssigneePickerDict = {
  searchPlaceholder: string;
  emptyMessage: string;
  nobody: string;
  youBadge: string;
  formerMember: string;
  shareConfirmTitle: string;
  shareConfirmBody: string;
  shareAndAssign: string;
  cancel: string;
  back: string;
  savedCue: string;
  lockedTooltip: string;
  lockedTooltipNamed?: string;
  lockedTooltipNamedMore?: string;
  loadError: string;
  assignedToast?: string;
  clearedToast?: string;
  bulkTitle?: string;
  bulkCount?: string;
  bulkPrivateNote?: string;
  bulkPrivateNotePlural?: string;
};

export function leadAssigneePickerLabelsFromDict(
  dict: AssigneePickerDict,
): LeadAssigneePickerLabels {
  return {
    searchPlaceholder: dict.searchPlaceholder,
    emptyMessage: dict.emptyMessage,
    nobody: dict.nobody,
    youBadge: dict.youBadge,
    formerMember: dict.formerMember,
    shareConfirmTitle: dict.shareConfirmTitle,
    shareConfirmBody: dict.shareConfirmBody,
    shareAndAssign: dict.shareAndAssign,
    cancel: dict.cancel,
    back: dict.back,
    savedCue: dict.savedCue,
    lockedTooltip: dict.lockedTooltip,
    lockedTooltipNamed: dict.lockedTooltipNamed ?? 'Can be changed by {names}',
    lockedTooltipNamedMore:
      dict.lockedTooltipNamedMore ??
      'Can be changed by {names} and {count} more',
    loadError: dict.loadError,
    assignedToast: dict.assignedToast ?? '{name}',
    clearedToast: dict.clearedToast ?? dict.nobody,
    bulkTitle: dict.bulkTitle,
    bulkCount: dict.bulkCount,
    bulkPrivateNote: dict.bulkPrivateNote,
    bulkPrivateNotePlural: dict.bulkPrivateNotePlural,
  };
}
